import type { RoofData, RoofFlags } from "building-types/roofs/roofSystemTypes";
import { RoofSide } from "building-types/settings/roofTypes";
import { assertUnreachable } from "common/utils/assertUnreachable";
import { ONE_MINUS_DIST_EPSILON } from "geom/core";
import { polyLine2EdgeNormal, polyLine2EdgeTangent } from "geom/polyLine2";
import type { PolyLine2 } from "geom/polyLine2Types";
import { vec2Dot } from "geom/vec2";

export function filterEdgeByRoofSide(edge: PolyLine2, midRail: PolyLine2, side: RoofSide): boolean {
  const [tX, tY] = polyLine2EdgeTangent(edge, 0);
  const [nX, nY] = polyLine2EdgeNormal(edge, 0);
  const [dirX, dirY] = polyLine2EdgeTangent(midRail, 0);

  switch (side) {
    case RoofSide.START: {
      return vec2Dot(nX, nY, dirX, dirY) < -ONE_MINUS_DIST_EPSILON;
    }
    case RoofSide.END: {
      return vec2Dot(nX, nY, dirX, dirY) > ONE_MINUS_DIST_EPSILON;
    }
    case RoofSide.LEFT: {
      return vec2Dot(tX, tY, dirX, dirY) < -ONE_MINUS_DIST_EPSILON;
    }
    case RoofSide.RIGHT: {
      return vec2Dot(tX, tY, dirX, dirY) > ONE_MINUS_DIST_EPSILON;
    }
    case RoofSide.INVALID: {
      return false;
    }
    default: {
      assertUnreachable(side);
    }
  }
}

export function hasRoofFlag(roofData: RoofData, flag: RoofFlags): boolean {
  if (!roofData.flags) {
    return false;
  }

  return roofData.flags[flag] ?? false;
}
